export default "__VITE_ASSET__RRHlvd94__"